import type {
  AggregationColumn,
  AggregationConfigByObjectType,
  AggregationObjectType,
} from './types';

type ClientQueryDataConfigObjectVersion = {
  active_selects: boolean;
  public_version: number;
  columns: AggregationColumn[];
};

export type ClientQueryDataConfigGetObjectsResponse = {
  data_objects: {
    object_display_name: string;
    object_slug: AggregationObjectType;
    versions: ClientQueryDataConfigObjectVersion[];
  }[];
};

function getActiveConfigObjectVersion(
  configObjectVersions: ClientQueryDataConfigObjectVersion[],
): ClientQueryDataConfigObjectVersion | undefined {
  return configObjectVersions.find(version => version.active_selects);
}

export function getFormattedAggregationConfig(
  clientQueryDataConfigObjects: ClientQueryDataConfigGetObjectsResponse['data_objects'],
): AggregationConfigByObjectType {
  return clientQueryDataConfigObjects.reduce((acc, configObject) => {
    const activeVersion = getActiveConfigObjectVersion(configObject.versions);

    if (!activeVersion) {
      return acc;
    }

    const { object_slug: objectSlug } = configObject;

    acc[objectSlug] = {
      columns: activeVersion.columns,
      objectDisplayName: configObject.object_display_name,
      publicVersion: activeVersion.public_version,
    };

    return acc;
  }, {} as AggregationConfigByObjectType);
}
